var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0003 29.3332C23.3641 29.3332 29.3337 23.3636 29.3337 15.9998C29.3337 8.63604 23.3641 2.6665 16.0003 2.6665C8.63653 2.6665 2.66699 8.63604 2.66699 15.9998C2.66699 23.3636 8.63653 29.3332 16.0003 29.3332Z",
    fill: "#8392A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9462 21.2399C20.7729 21.2399 20.5995 21.1998 20.4395 21.0932L16.3062 18.6265C15.2795 18.0132 14.5195 16.6665 14.5195 15.4798V10.0132C14.5195 9.46652 14.9729 9.01318 15.5195 9.01318C16.0662 9.01318 16.5195 9.46652 16.5195 10.0132V15.4798C16.5195 15.9598 16.9195 16.6665 17.3329 16.9065L21.4662 19.3732C21.9462 19.6532 22.0929 20.2665 21.8129 20.7465C21.6129 21.0665 21.2795 21.2399 20.9462 21.2399Z",
    fill: "#8392A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.4b5c54658e952e9c996887ee1d9711de.svg";
export { ForwardRef as ReactComponent };